import { LocationWebhookFieldDTOe } from './location-webhook-field.dto';

export interface LocationWebhookConfigDTOe {
  active       : boolean;
  companyID    : number | null;
  endpointUrl  : string | null;
  fields?      : LocationWebhookFieldDTOe[];
  id           : number | null;
  partnerIdRef?: string | null;
  secret       : string | null;
}

export function LocationWebhookConfigDTOe_EmptyObject(): LocationWebhookConfigDTOe {
  return {
    active     : false,
    companyID  : null,
    endpointUrl: null,
    id         : null,
    secret     : null
  };
}
